import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-left: 1px solid rgba(0, 87, 84, 0.1);
  background: ${(props) => (props.match ? "#F8FBFB" : "white")};
  height: 100%;
  padding: 0 30px;
  white-space: nowrap;
`;

const HeaderText = styled.div`
  color: #005754;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  @media (max-width: 1280px) {
    font-size: 14px;
  }
`;

const Image = styled.img`
  margin: 0 8px 0 0;
  width: 24px;
  height: 24px;
  @media (max-width: 1280px) {
    width: 21px;
    height: 21px;
  }
`;

const HeaderLink = ({
  text,
  image,
  activeImage,
  match = false,
  active = false,
  showText = true
}) => (
  <Container active={active} match={match}>
    <Image src={active ? activeImage : image} alt="alt" />
    {showText && <HeaderText>{text}</HeaderText>}
  </Container>
);

export default HeaderLink;
